import { AssetsRoutes } from "./AssetsRoutes";

export const AssetsPage = () => {   
    return <AssetsRoutes />    
}